module.exports = __webpack_public_path__ + "static/img/end.061cc33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Melon/end.jpg
// module id = QDT4
// module chunks = 1